import { getLayerConfig } from '../WaterQualityLayer/water-quality-layer.utils';

import {
  formatValue,
  getHoveredValue,
  getMarkerOffset,
  VIRIDIS_GRADIENT,
} from './interactive-legend.utils';

import './interactive-legend.css';

function InteractiveLegend({
  selectedLayer,
  hoveredPixelColor,
}) {
  const layerConfig = getLayerConfig(selectedLayer);

  if (!layerConfig) {
    return null;
  }

  const [minValue, maxValue] = layerConfig.rescale;
  const hoveredValue = getHoveredValue(hoveredPixelColor, minValue, maxValue);
  const markerOffset = getMarkerOffset(hoveredValue, minValue, maxValue);

  return (
    <div className="pagasitikos-gulf-map__overlay pagasitikos-gulf-map__overlay--bottom-right interactive-legend">
      <div className="interactive-legend__unit">
        {layerConfig.unit}
      </div>
      <div className="interactive-legend__bound interactive-legend__bound--top">{formatValue(maxValue)}</div>
      <div className="interactive-legend__scale-wrap">
        <div className="interactive-legend__scale" style={{ background: VIRIDIS_GRADIENT }} />
        {markerOffset !== null && (
          <div
            className="interactive-legend__marker"
            style={{ bottom: `calc(${markerOffset}% - 10px)` }}
          >
            <div className="interactive-legend__marker-value">{formatValue(hoveredValue)}</div>
            <div className="interactive-legend__marker-pointer" />
          </div>
        )}
      </div>
      <div className="interactive-legend__bound interactive-legend__bound--bottom">{formatValue(minValue)}</div>
    </div>
  );
}

export default InteractiveLegend;
